/* jshint esversion: 6 */
/* jshint ignore:start */
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import AppleIcon from "../assets/Image/AppLogo.png";
import PlaystoreIcon from "../assets/Image/Playstore.png";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { MyContext } from "../Context/MyProvider";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../assets/Image/Logo.png";
const Footer = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl, setActivePage } = useContext(MyContext);

    const [pageList, setPageList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        axios.post(`${ApiBaseUrl}/customer/pages`)
            .then((res) => {
                // console.log("/customer/pages", res);
                setPageList(res.data.pages_data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const HandleNavigate = (path, id) => {
        setActivePage(id);
        navigate(`/${path}`, { state: true });
    };

    const HandleOpenLink = (Link) => {
        window.open(Link, "blank");
    }

    return (
        <div className='bg-black rounded-t-[30px] p-[20px] md:p-[35px]'>
            <div className="bg-white rounded-[30px] p-[20px] md:p-[25px]">
                <div className="flex flex-col md:flex-row items-start justify-between gap-[20px] pt-[20px]">
                    <div className="">
                        <Link to="/">
                            <img src={Logo} className="w-[70px]" alt="logo" />
                        </Link>
                        <p className='text-[18px] mt-[30px]'>{t("A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,")} <br /> {t("managing, and attending doctor's appointments.")}</p>
                    </div>
                    <div className="flex items-center gap-[15px]">
                        {[FaFacebookF, FaTwitter, FaInstagram, FaYoutube].map((Icon, idx) => (
                            <div key={idx} className="bg-[#a0e1e154] p-[8px] rounded-full group cursor-pointer">
                                <Icon className='text-[20px]' />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex flex-wrap items-center gap-[20px] my-[20px]">
                    {pageList.map((item, index) => {
                        const Title = item.title.replace(/\s+/g, '_');
                        const FinalText = Title.toLowerCase();

                        return <div onClick={() => HandleNavigate(`${FinalText}`, (index + 8))} key={index} className="cursor-pointer group">
                            <h1 className="font-[500] text-[16px] group-hover:text-gray-700">{item.title}</h1>
                        </div>
                    })}
                </div>

                <div className="flex flex-col md:flex-row items-center justify-between gap-[20px] pt-[20px] border-t-[1px]">
                    <h1>{t("@ Powered By")} Aiahwellness</h1>
                    <div className="flex flex-wrap items-center gap-[10px]">
                        <button onClick={() => HandleOpenLink("https://apps.apple.com/")}>
                            <img src={AppleIcon} className='w-[130px] md:w-[150px] cursor-pointer' alt="App Store" />
                        </button>
                        <button onClick={() => HandleOpenLink("https://play.google.com/")}>
                            <img src={PlaystoreIcon} className='w-[130px] md:w-[150px] cursor-pointer' alt="Play Store" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
/* jshint ignore:end */